import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router does client-side navigation, so the browser never gets the
 * "fresh page load" scroll reset you'd get with a normal <a> link. Without
 * this, clicking a footer/nav link (About, FAQ, Privacy, Contact, Terms —
 * or any link) while scrolled down a long page leaves the user stranded at
 * the same scroll offset on the new page, looking at whatever content
 * happens to land there instead of the top.
 *
 * Mount once inside <Router>, above/alongside <Routes>. Keyed on
 * `pathname` only (not the full location), so in-page hash anchors like
 * TutorProfilePublic's "#booking" link — which don't change the pathname —
 * are left alone and keep their normal browser scroll-into-view behavior.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
